<!--精准读书会-活动详情-->
<template>
    <div class="club-info-container" v-loading="loading">
        <!-- 顶部标题栏 -->
        <div class="club-info-header">
            <div class="club-header-placeholder"></div>
            <div class="club-info-title" :title="eventForm.eventTheme">{{ eventForm.eventTheme || '读书会详情' }}</div>
            <div class="club-back-btn" @click="backPage">⇦返回</div>
        </div>

        <!-- 主内容区 -->
        <div class="club-info-main">
            <!-- 左侧详情 -->
            <div class="club-info-left">
                <!-- 活动信息 -->
                <div class="club-info-row">
                    <span class="club-info-label">活动主题：</span>
                    <span class="club-info-value">{{ eventForm.eventTheme || '-' }}</span>
                </div>
                <div class="club-info-row">
                    <span class="club-info-label">所属主题：</span>
                    <span class="club-info-value">{{ eventForm.eventItemName || '-' }}</span>
                </div>
                <div class="club-info-row">
                    <span class="club-info-label">学段年级：</span>
                    <span class="club-info-value">{{ eventForm.periodName }}{{ eventForm.eventGradeName ? '·' + eventForm.eventGradeName : '' }}</span>
                </div>
                <div class="club-info-row">
                    <span class="club-info-label">活动时长：</span>
                    <span class="club-info-value">{{ eventForm.eventTime || '-' }}</span>
                </div>

                <!-- 核心读物 -->
                <div class="club-info-section" v-if="eventBookList && eventBookList.length > 0">
                    <div class="club-section-label">核心读物：</div>
                    <div class="club-book-list">
                        <div class="club-book-item" v-for="(item, index) in eventBookList" :key="index">
                            <div class="club-book-cover">
                                <img :src="item.bookCover" :alt="item.bookName"/>
                            </div>
                            <div class="club-book-name" :title="item.bookName">{{ item.bookName }}</div>
                        </div>
                    </div>
                </div>

                <!-- 活动准备 -->
                <div class="club-info-section" v-if="eventForm.eventPrepare">
                    <div class="club-section-label">活动准备：</div>
                    <div class="club-info-content">{{ eventForm.eventPrepare }}</div>
                </div>

                <!-- 活动流程 -->
                <div class="club-info-section" v-if="eventForm.eventFlow">
                    <div class="club-section-label">活动流程：</div>
                    <div class="club-info-content">{{ eventForm.eventFlow }}</div>
                </div>

                <!-- 活动附件 -->
                <div class="club-info-section">
                    <div class="club-section-label">活动附件：</div>
                    <div class="club-file-list" v-if="fileList && fileList.length > 0">
                        <div class="club-file-item" v-for="(item, index) in fileList" :key="index">
                            <div class="club-file-name">{{ item.fileName }}</div>
                            <div class="club-file-actions">
                                <div class="club-file-action" v-if="judgeIsPPT(item.fileType)" @click="viewPPTFile(item.fileUrl)" title="预览">
                                    <img src="@/assets/file/ppt_play.png" alt="预览"/>
                                </div>
                                <div class="club-file-action" @click="handleDownload(item)" title="下载">
                                    <img src="@/assets/file/file_download.png" alt="下载"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club-no-file" v-else>暂无附件</div>
                </div>
            </div>

            <!-- 右侧封面 -->
            <div class="club-info-right">
                <div class="club-section-label">活动封面：</div>
                <div class="club-cover">
                    <img :src="eventForm.eventCover" alt="活动封面"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {infoEvent} from "@/api/admin/museum";
import {downloadFile} from "@/api/adminservice/public";

export default {
    name: "readClubInfo",
    components: {},
    data() {
        return {
            loading:false,
            eventForm:{},
            eventBookList:[],
            fileList:[],
        }
    },
    computed: {},
    props:{
        eventId:{
            type: [String,Number],
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.queryEventInfo();
        },
    },
    created() {
        this.queryEventInfo();
    },
    mounted() {},
    methods: {
        /*查询读书会详情*/
        queryEventInfo() {
            if (!this.eventId) return;
            this.loading = true;
            infoEvent({ eventId: this.eventId }).then(res => {
                if (res.data.code === 1) {
                    this.eventForm = res.data.data || {};
                    this.eventBookList = this.eventForm.bookList || [];
                    this.fileList = this.eventForm.fileList || [];
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        /*文件操作*/
        judgeIsPPT(fileType) {
            if (!fileType) return false;
            return fileType.toLowerCase().includes("ppt");
        },
        viewPPTFile(fileUrl) {
            const openUrl = "https://ow365.cn/?i=36735&ssl=1&furl=" + fileUrl;
            window.open(openUrl, "_blank");
        },
        handleDownload(item) {
            downloadFile(item.fileUrl, item.fileName);
        },
        backPage(){
            this.$emit('back-page');
        }
    }
}
</script>

<style scoped>
.club-info-container{
    width: 100%;
    height: 100%;
    padding: 10px 30px 20px 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 顶部标题栏 */
.club-info-header{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}
.club-back-btn{
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    background: #ff7f2e;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
}
.club-info-title{
    flex: 1;
    min-width: 0;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    font-weight: bold;
    letter-spacing: 1px;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.club-header-placeholder{
    width: 80px;
    flex-shrink: 0;
}

/* 主内容区 */
.club-info-main{
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    gap: 30px;
    overflow: hidden;
}
.club-info-left{
    flex: 1;
    min-width: 0;
    height: 100%;
    overflow-y: auto;
    padding-right: 10px;
    box-sizing: border-box;
}
.club-info-right{
    width: 260px;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
}
.club-info-left::-webkit-scrollbar,
.club-info-right::-webkit-scrollbar{
    width: 6px;
}
.club-info-left::-webkit-scrollbar-thumb,
.club-info-right::-webkit-scrollbar-thumb{
    background: #d1d5db;
    border-radius: 3px;
}

/* 通用标签与内容 */
.club-section-label,
.club-info-label{
    font-size: 15px;
    color: #ff7f2e;
    font-weight: bold;
    flex-shrink: 0;
}
.club-info-row{
    display: flex;
    align-items: baseline;
    font-size: 14px;
    line-height: 2;
}
.club-info-label{
    margin-right: 6px;
}
.club-info-value{
    color: #1f2937;
}
.club-info-section{
    margin-top: 16px;
}
.club-info-content{
    font-size: 14px;
    color: #374151;
    line-height: 1.8;
    text-align: justify;
    padding-left: 2px;
    white-space: pre-wrap;
}

/* 核心读物 */
.club-book-list{
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
}
.club-book-item{
    width: 120px;
    display: flex;
    flex-direction: column;
}
.club-book-cover{
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 6px;
    background-color: #f3f4f6;
    border-radius: 6px;
}
.club-book-cover img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.club-book-name{
    width: 100%;
    font-size: 13px;
    color: #1f2937;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 附件 */
.club-file-list{
    margin-top: 8px;
}
.club-file-item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    background-color: #ffffff;
    border-radius: 6px;
    margin-bottom: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.club-file-name{
    font-size: 14px;
    color: #1f2937;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.club-file-actions{
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 12px;
}
.club-file-action{
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.club-file-action img{
    width: 20px;
    height: 20px;
    object-fit: contain;
}
.club-no-file{
    font-size: 14px;
    color: #9ca3af;
    padding: 10px 0;
}

/* 右侧封面 */
.club-cover{
    width: 100%;
    height: 180px;
    margin-top: 8px;
    margin-bottom: 16px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #f3f4f6;
    border-radius: 6px;
}
.club-cover img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
</style>
